import React from 'react';
import classNames from 'classnames';

export class Title extends React.Component {
  constructor (props) {
    super(props);
    this.parts = props.content ? props.content.split('\n') : ['', ''];
    let top = this.parts.shift();
    let bottom = this.parts.join('\n');
    this.state = { top, bottom };
  }

  get className () {
    return classNames({
      'title': true,
      'typo-title': true,
      'animated': this.props.animated
    })
  }

  render () {
    return (
      <div className={ this.className }>
        <div className="title__top">
          <div className="title__top__text">{ this.state.top }</div>
        </div>
        <div className="title__bottom">
          <div className="title__bottom__text">{ this.state.bottom }</div>
        </div>
      </div>
    );
  }
}
